// c端用户权限管理
export default {
  add: "clientOperationRoleManage_add",
  delete: "clientOperationRoleManage_delete",
  edit: "clientOperationRoleManage_edit",
  status: "clientOperationRoleManage_status",
}